/** Debounce / max-wait tuning for persisted query cache writes. */
export const PERSIST_DEBOUNCE_MS = {
  native: 10_000,
  web: 2_000,
};

export const PERSIST_MAX_WAIT_MS = {
  native: 45_000,
  web: 10_000,
};

/** @deprecated Prefer PERSIST_DEBOUNCE_MS — kept for sync persister fallback. */
export const PERSIST_THROTTLE_MS = 1_000;
